// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"UQ-fHqaFlN1aMgnB0JwqY","title":"_3v1MApi5BUIP0_soH6yrIJ","formControl":"_2Q5AHdDWPsiQIFz9I95Tzd","textArea":"_2y38avc72e-t7i36mCpUyM","label":"_2kVI2gMKu6rhcCg8el1jv9","buttonSection":"_3VdpH05zeu2h9i1b_am9we"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Journal/components/EditNote.mod.css
// module id = 1133
// module chunks = 0